import { create } from "zustand";

export interface CartItem {
  producto_id: number;
  sku: string;
  nombre: string;
  cantidad: number;
  precio_unit: number;
  // Para productos pesables, cantidad es kg.
  pesable?: boolean;
}

export type MedioPago =
  | "efectivo"
  | "debito"
  | "credito"
  | "transferencia"
  | "cta_cte"
  | "mp_qr"
  | "mp_point";

export interface Pago {
  medio: MedioPago;
  monto: number;
  mp_payment_id?: string;
}

export interface ClienteRef {
  id: number;
  nombre: string;
  cuit?: string | null;
}

interface CartState {
  items: CartItem[];
  cliente: ClienteRef | null;
  descuento: number;
  pagos: Pago[];
  addItem: (it: CartItem) => void;
  removeItem: (producto_id: number) => void;
  setQty: (producto_id: number, cantidad: number) => void;
  setCliente: (c: ClienteRef | null) => void;
  setDescuento: (n: number) => void;
  setPagos: (p: Pago[]) => void;
  clear: () => void;
  total: () => number;
  subtotal: () => number;
}

export const useCart = create<CartState>((set, get) => ({
  items: [],
  cliente: null,
  descuento: 0,
  pagos: [],
  addItem: (it) =>
    set((s) => {
      const existing = s.items.find((x) => x.producto_id === it.producto_id);
      if (existing && !it.pesable) {
        return {
          items: s.items.map((x) =>
            x.producto_id === it.producto_id
              ? { ...x, cantidad: x.cantidad + it.cantidad }
              : x
          ),
        };
      }
      return { items: [...s.items, it] };
    }),
  removeItem: (id) =>
    set((s) => ({ items: s.items.filter((x) => x.producto_id !== id) })),
  setQty: (id, cantidad) =>
    set((s) => ({
      items: s.items.map((x) =>
        x.producto_id === id ? { ...x, cantidad } : x
      ),
    })),
  setCliente: (c) => set({ cliente: c }),
  setDescuento: (n) => set({ descuento: n }),
  setPagos: (p) => set({ pagos: p }),
  clear: () =>
    set({ items: [], cliente: null, descuento: 0, pagos: [] }),
  subtotal: () =>
    get().items.reduce((acc, x) => acc + x.cantidad * x.precio_unit, 0),
  total: () => {
    const sub = get().subtotal();
    const d = get().descuento;
    return Math.max(0, sub - d);
  },
}));
